import React from 'react'

import './counter-tag.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'span'>,
  {
    children: React.ReactNode
    appearance?: 'base' | 'alternative'
    disabled?: boolean
  }
>

const CounterTag = ({
  className,
  children,
  appearance = 'base',
  disabled = false,
  ...props
}: Props) => (
  <span
    {...props}
    className={cn('CounterTag', {[`appearance-${appearance}`]: true, disabled}, className)}
  >
    {children}
  </span>
)

export default CounterTag
